import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Card } from 'primereact/card';
import { Button } from "primereact/button";

import "./styles.css";

const PaineisApropriadores = ({ paineis, usuario }) => {
    const activeIndex = 0
    const history = useHistory();

    const renderActions = (painel) => {
        return (
            <span className="questionario-actions">
                <Button
                    label="GERENCIAR PAINEL"
                    icon="pi pi-arrow-right"
                    style={{ bottom: 32 }}
                    onClick={() => {
                        history.push({
                            pathname: `/painelapropriador/id/${painel.id}`,
                            state: { painel: painel }
                        });
                    }}
                />
            </span>
        )
    };

    const renderDisponiveis = () => {
        if (!paineis) {
            return renderSemPaineisDisponiveis();
        }
        return (
            <AccordionTab header="Painéis de ações de melhoria disponíveis">
                {paineis.map(painel => {
                    let titulo = (
                        <div>
                            <i className="pi pi-star" /> {painel.nivelOrganizacional['CAMPUS']}
                            <br />
                            <i className="pi pi-sitemap" /> {painel.nivelOrganizacional['CURSO']}
                        </div>
                    );
                    return (
                        <Card
                            className="disponivel" id='painel-apropriador'
                            key={painel.id}
                            title={titulo}
                            subTitle={`DISPONÍVEL ATÉ ${new Date(painel.terminoAplicacao).toLocaleString()}`}
                            footer={renderActions(painel)}
                        >
                            <div><p>Proprietário: {painel.proprietario}</p></div>
                        </Card>
                    )
                })}
            </AccordionTab>
        );
    }

    const renderSemPaineisDisponiveis = () => (
        <p style={{ 'textAlign': "center" }}>
            <i className="pi pi-exclamation-triangle" style={{ 'fontSize': '2em' }}></i>
            <br />Não há painéis de ações de melhoria disponíveis para você gerenciar.
        </p>
    )

    useEffect(() => {

    }, []);

    return (
        <div className="paineis-apropriadores">
            <Accordion activeIndex={activeIndex}>
                {renderDisponiveis()}
            </Accordion>
        </div>
    );
}

export default PaineisApropriadores;